module.exports = __webpack_public_path__ + "img/bg-activity.882ce170.png";